import { createReducer } from '@mews/framework';
import { DATA_TO_FETCH_SET, ENTERPRISE_RATE_MANAGEMENT_INIT_SUCCEEDED, FETCH_FLAG_SET } from '../actionTypes';
import { DataType, ServerSyncState } from '../types';

const initialState: ServerSyncState = {
    isInitialized: {
        [DataType.RateType]: false,
        [DataType.VoucherType]: false,
    },
    dataType: null,
    shouldFetch: true,
    dataToFetch: null,
};

const serverSyncReducer = createReducer(initialState, {
    [ENTERPRISE_RATE_MANAGEMENT_INIT_SUCCEEDED]: ({ isInitialized, ...other }: ServerSyncState) => ({
        ...other,
        isInitialized: {
            ...isInitialized,
            [DataType.RateType]: true,
        },
    }),
    [DATA_TO_FETCH_SET]: (
        state: ServerSyncState,
        { dataType, dataToFetch }: Pick<ServerSyncState, 'dataType' | 'dataToFetch'>
    ) => ({
        ...state,
        shouldFetch: true,
        dataType,
        dataToFetch,
    }),
    [FETCH_FLAG_SET]: ({ dataToFetch, ...other }: ServerSyncState, flagValue: boolean) => ({
        ...other,
        shouldFetch: flagValue,
        dataToFetch: flagValue ? dataToFetch : null,
    }),
});

export default serverSyncReducer;
